import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function TraceabilityReceivingItemLookupViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [histories, setHistories] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const clearResult = () => {
    setItem(null);
    setInvoice(null);
    setHistories([]);
    setNotFound(false);
  };

  const onLookupBarcode = async function (barcode) {
    const trimmed = (barcode || "").trim();
    if (!trimmed) return;

    setLoading(true);
    setHasSearched(true);
    clearResult();

    const callResult = await makePostApiCall(`fetchReceivingBarcodeHistory`, {
      barcode: trimmed,
    });

    if (callResult.success) {
      setItem(callResult.data?.item || null);
      setInvoice(callResult.data?.invoice || null);
      setHistories(
        Array.isArray(callResult.data?.histories) ? callResult.data.histories : [],
      );
    } else if (callResult.errorStatus === 404) {
      setNotFound(true);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data?.message || "Could not fetch barcode history.");
    }

    setLoading(false);
  };

  return {
    loading,
    item,
    invoice,
    histories,
    hasSearched,
    notFound,
    onLookupBarcode,
    emptyModal,
    setEmptyModelOpen,
  };
}
